import React from "react";
import { Line, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const getDarkOptions = (label) => ({
  responsive: true,
  scrollX:true,
  maintainAspectRatio: false,
  pointLabel:false,
  plugins: {
    legend: {
      display: false,
      labels: { color: "white" },
    },
    title: {
      display: false,
      color: "white",
    },
    point:{
      display:false
    },
    tooltip: {
      backgroundColor: "#20293F",
      titleColor: "white",
      bodyColor: "#c7d2fe",
    },
     datalabels: { display: false } 
  },
  scales: {
    x: {
      ticks: { color: "#c7d2fe" },
      grid: { color: "#334155" },
    
    },
    y: {
      ticks: { color: "#c7d2fe" },
      grid: { color: "#334155" },
    },
   
  },
  
});

const getLightOptions = (label) => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    title: { display: false },
  },
});

const WeatherGraphs = ({ hourlyData, dailyData, darkMode }) => {
  // Hourly labels with date (e.g., Today 13:00, Tomorrow 14:00...)
  const hourlyLabels = hourlyData.map((h) => {
    const date = new Date(h.dt * 1000);
    const isToday = date.toDateString() === new Date().toDateString();
    const isTomorrow = date.toDateString() === new Date(Date.now() + 86400000).toDateString();
    const isYesterday = date.toDateString() === new Date(Date.now() - 86400000).toDateString();
    
    let dateLabel = date.getDate();
    // if (isToday) dateLabel = "Today";
    // else if (isTomorrow) dateLabel = "Tomorrow";
    // else if (isYesterday) dateLabel = "Yesterday";
    // else dateLabel = date.toLocaleDateString([], { month: "short", day: "numeric" });
    
    return `${dateLabel} - ${date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;
  });
  // Daily labels (e.g., Mon, Tue...)
  const dailyLabels = dailyData.map((d) =>
    new Date(d.dt * 1000).toLocaleDateString([], { weekday: "short" })
  );

  // Chart data
  const tempHourly = {
    labels: hourlyLabels,
    datasets: [
      {
        label: "Temperature (°F)",
        data: hourlyData.map((h) => Math.round(h.temp * 9/5 + 32)),
     borderColor: darkMode ? "#3662E3" : "#10b981",
        backgroundColor: darkMode ? "white" : "#10b981",
        fill: true,
        tension: 0.4,
      },
    ],
  };
  const popHourly = {
    labels: hourlyLabels,
    datasets: [
      {
        label: "Precipitation (%)",
        data: hourlyData.map((h) => Math.round((h.pop || 0) * 100)),
   borderColor: darkMode ? "white" : "#10b981",
        backgroundColor: darkMode ? "#3662E3" : "#10b981",
      },
    ],
  };
  const windHourly = {
    labels: hourlyLabels,
    datasets: [
      {
        label: "Wind Speed (mph)",
        data: hourlyData.map((h) => Number((h.wind_speed * 2.237).toFixed(2))),
        borderColor: darkMode ? "#3662E3" : "#10b981",
        backgroundColor: darkMode ? "white" : "#10b981",
        fill: true,
        tension: 0.4,
    
      
      },
    ],
    
  };
  const tempDaily = {
    labels: dailyLabels,
    datasets: [
      {
        label: "Min (°F)",
        data: dailyData.map((d) => Math.round(d.temp.min * 9/5 + 32)),
        backgroundColor: darkMode ? "#60a5fa" : "#60a5fa",
      },
      {
        label: "Max (°F)",
        data: dailyData.map((d) => Math.round(d.temp.max * 9/5 + 32)),
        backgroundColor: darkMode ? "#f59e42" : "#f59e42",
      },
    ],
  };

  const cardClass = darkMode
    ? "bg-blueGray   border border-borderGray bg-opacity-95 rounded-xl shadow-lg p-3 sm:p-6"
    : "bg-white bg-opacity-90 rounded-xl shadow-lg p-3 sm:p-6";
  const headingClass = darkMode
    ? "font-semibold mb-2 sm:mb-4 text-base sm:text-lg text-white"
    : "font-semibold mb-2 sm:mb-4 text-base sm:text-lg";

  return (
    <div className="w-full max-w-7xl flex flex-col gap-4 sm:gap-8 mb-8">
      {hourlyData && hourlyData.length > 0 && (
        <>
          <div className={cardClass + " h-60 sm:h-64 md:h-80"}>
            <h3 className={headingClass}>Hourly Temperature (°F)</h3>
            <div className="relative h-[calc(100%-2rem)] w-full">
              <Line scaleX={true} data={tempHourly} options={darkMode ? getDarkOptions() : getLightOptions()} />
            </div>
          </div>
          <div className={cardClass + " h-60 sm:h-64 md:h-80"}>
            <h3 className={headingClass}>Hourly Precipitation Probability (%)</h3>
            <div className="relative h-[calc(100%-2rem)] w-full">
              <Bar data={popHourly} options={darkMode ? getDarkOptions() : getLightOptions()} />
            </div>
          </div>
          <div className={cardClass + " h-60 sm:h-64 md:h-80 w-full "}>
            <h3 className={headingClass}>Hourly Wind Speed (mph)</h3>
            <div className="relative h-[calc(100%-2rem)]  w-full  overflow-x-auto ">
              <Line 
              scaleX={true} data={windHourly} options={darkMode ? getDarkOptions() : getLightOptions()} />

            </div>
          </div>
        </>
      )}
      {dailyData && dailyData.length > 0 && (
        <div className={cardClass + " h-60 sm:h-64 md:h-80"}>
          <h3 className={headingClass}>Daily Min/Max Temperature (°F)</h3>
          <div className="relative h-[calc(100%-2rem)] w-full">
            <Bar data={tempDaily} options={darkMode ? getDarkOptions() : getLightOptions()} />
          </div>
        </div>
      )}
    </div>
  );
};

export default WeatherGraphs;